export const HOME_PAGE = '/'
export const OOS_PAGE = '/oos'
export const SKU_PAGE = '/check-stock'
export const UPLOAD_PAGE = '/upload'
export const LOGIN_PAGE = '/login'
export const API_KEY_PAGE = '/keys'
export const MIGRATION_PAGE = '/supplier_migration'
